"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definitionFromConfig = exports.getConfigurationFromDefinition = exports.buildConfigurationText = void 0;
var metricValue_1 = require("../features/metricValue");
var threshold_1 = require("../features/threshold");
var status_1 = require("../features/status");
var window_1 = require("../features/window");
var comparisonText_1 = require("../formatting/comparisonText");
var dateFormatter_1 = require("../formatting/dateFormatter");
var models_1 = require("../models");
var comparison_1 = require("../features/comparison");
var buildConfigurationText = function (definition, isSingleNumber) {
    var isConstantComparison = (0, threshold_1.isDefaultLineStaticRefLine)(definition);
    var showWindowText = !isSingleNumber;
    var showComparisonText = (isSingleNumber && isConstantComparison) || !isSingleNumber;
    var comparisonText = (0, comparisonText_1.getAuthoredComparisonText)(definition);
    var serverWindow = (0, window_1.getFirstWindow)(definition);
    var windowText = serverWindow && (0, window_1.displayStringFromWindow)(serverWindow);
    if (serverWindow && (0, window_1.isCustomWindow)(serverWindow)) {
        var startDate = serverWindow.range.first;
        var dateTrunc = (0, models_1.dateTruncFromGranularity)((0, metricValue_1.getTimestampGranularity)(definition));
        windowText = (0, dateFormatter_1.dateFormatterFactory)(dateTrunc).configurationInfoStartDate(startDate);
    }
    else if (serverWindow && (0, window_1.isDefinedStartWindow)(serverWindow)) {
        var dateTrunc = (0, models_1.dateTruncFromGranularity)((0, metricValue_1.getTimestampGranularity)(definition));
        windowText = (0, dateFormatter_1.dateFormatterFactory)(dateTrunc).configurationInfoStartDate(serverWindow.startDate);
    }
    return {
        comparisonText: showComparisonText ? comparisonText : undefined,
        windowText: showWindowText ? windowText : undefined,
    };
};
exports.buildConfigurationText = buildConfigurationText;
var getConfigurationFromDefinition = function (flags, definition) {
    var _a;
    var comparison = (_a = (0, comparison_1.getComparisonFromDefinitionAndFlags)(flags, definition)) !== null && _a !== void 0 ? _a : null;
    var dateTrunc = (0, models_1.dateTruncFromGranularity)((0, metricValue_1.getTimestampGranularity)(definition));
    var window = flags.areDateWindowsEnabled ? (0, window_1.getFirstWindowOrDefault)(definition) : (0, window_1.defaultDateWindow)(dateTrunc);
    var status = flags.isColorStatusIndicatorsEnabled ? (0, status_1.getAuthoredStatus)(definition) : status_1.NullStatus;
    return { comparison: comparison, window: window, status: status };
};
exports.getConfigurationFromDefinition = getConfigurationFromDefinition;
function definitionFromConfig(config, defToStartWith) {
    var definition = defToStartWith;
    if (config.window) {
        definition = (0, window_1.definitionWithWindow)(definition, config.window);
    }
    if (config.comparison) {
        definition = (0, comparison_1.definitionWithComparison)(definition, config.comparison, !(0, models_1.shouldShowComparisonLine)(config.comparison));
        if (config.comparison.type === 'STATIC_COMPARISON') {
            definition = (0, status_1.definitionWithStatus)(definition, nonNullStatus(config.status)).unwrap();
        }
    }
    return definition;
}
exports.definitionFromConfig = definitionFromConfig;
var nonNullStatus = function (status) {
    var _a, _b, _c;
    return {
        above: (_a = status.above) !== null && _a !== void 0 ? _a : status_1.ThresholdStatus.UNKNOWN,
        equal: (_b = status.equal) !== null && _b !== void 0 ? _b : status_1.ThresholdStatus.UNKNOWN,
        below: (_c = status.below) !== null && _c !== void 0 ? _c : status_1.ThresholdStatus.UNKNOWN,
    };
};
//# sourceMappingURL=Configuration.js.map